module.exports = __webpack_public_path__ + "img/bg.7e6344cc.png";